import React from 'react';

const RightArrow = ({ width = 16, height = 17, color = '#7357E9', ...rest }) => {
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="vuesax/linear/arrow-right">
        <g id="arrow-right">
          <path
            id="Vector"
            d="M9.61719 4.45312L13.6639 8.49979L9.61719 12.5465"
            stroke={color}
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            id="Vector_2"
            d="M2.33594 8.5H13.5559"
            stroke={color}
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default RightArrow;
